import React from 'react';

export default function SingleCard({ title, description, children }) {
  return (
    <>
        {children}
    </>
)}
